export const ConsolidatedMapper = (data) => {
    if (data) {
        const initial = new Array();
        const { holdingDetail, holdingSummary } = data;
        const mappedHoldingDetails = holdingDetail.reduce((acc, record) => {
            acc.push(Object.assign(Object.assign({}, record), { changePercentage: "", displayName: "", lastTradedPrice: 0 }));
            return acc;
        }, initial);
        return {
            holdingDetail: mappedHoldingDetails,
            holdingSummary: holdingSummary,
        };
    }
    else {
        return null;
    }
};
